// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    //AMBIENTE jlgranda.
    api: "https://prod.facturafacilecuador.com:8443/appsventas-auth-0.0.1/",
    credential_app: "dXNyX2FwcGF0cGE6cHJ1ZWI0c19BVFBBXzIwMjA",
    auth: "api/auth/login",
    settings: {
        env: {
            name: "PROD",
        },
        app: {
            name: "FacturaFácil Ecuador",
            subtitle: "¡Soluciones Fáciles, seguras y PROfesionales para tu negocio!",
            right: "Todos los derechos reservados",
            inactivity_time: 1800,
            version: {
                id: 3.6,
                nombre: "PROD"
            },
            files: {
                accept: ".p12"
            },
            contact: {
                name: 'facturafacilecuador.com',
                phone: '099 9900 408',
                email: 'info@facturafacilecuador.com',
                url: 'https://www.facturafacilecuador.com/'
            },
            help: {
                name: 'facturafacilecuador.com',
                url: 'https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_nueva_factura.pdf'
            },
            text: { 
                max_length: 256 
            },
            iva: { 
                id: '2',
                factor: 15,
                etiqueta: '15%',
                ayuda: '' 
            },
            ivas: [ 
                { 
                    id: '2',
                    factor: 12,
                    etiqueta: '12%',
                    desde: new Date('1981-01-01T00:00:00Z'),
                    hasta: new Date('2024-03-31T23:59:00Z'),
                    ayuda: '' 
                }, 
                { 
                    id: '2',
                    factor: 15,
                    etiqueta: '15%',
                    desde: new Date('2024-04-01T00:00:00Z'),
                    hasta: new Date('2099-04-30T23:59:00Z'),
                    ayuda: '' 
                }, 
            ]
        },
        appInsights: {
            instrumentationKey: "<dev-guid-here>",
        },
        logging: {
            console: true,
            appInsights: false,
        },
        apiServer: "https://prod.facturafacilecuador.com:8443/fazil-micro",
        validationRegExp: {
            urlPattern: "^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&'\\(\\)\\*\\+,;=.]+$",
            tileURLPattern: "^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]%{}@!\\$&'\\(\\)\\*\\+,;=.]+$",
            urlInteroperabilidadPattern: "^((?:http(s)?:\\/)?[?\\/])+[\\w]+[\\w\\-\\._~:/?#[\\]{}@!\\$&'\\(\\)\\*\\+,;=.]+$",
            usernamePattern: "^[a-z0-9_-]s{8,15}$",
            emailPattern: "^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$",
            numberPattern: "^[0-9.]+$",
            codigoPattern: "^[a-zA-Z0-9-_]{5,16}$",
            prefixPattern: "^[a-zA-Z0-9_]{2,7}$",//Prefijo de campo de DB
            fieldNamePattern: "^[a-zA-Z0-9/./_’'?]{2,57}$",//Nombre de campo de DB
            cedulaPattern: "^[0-9]{10}$",
            rucPattern: "^[0-9]{13}$",
            cirucPattern: "^[0-9]{10,13}$",
            establishmentPattern: "^[0-9]{3}$",
            siglasPattern: "^[a-zA-Z0-9-_]{2,16}$",//Nombre comercial corto ejm: RISE SRI
            safeTextPattern: "^[a-zA-Z0-9ÁÉÍÓÚÑáéíóúñ/\\[\\(.?¿\\)\\]/\\s/\\s,/\\s;/\\s:-]{3,128}$",//Texto seguro ejm: nombre, dirección, descripción en caja de texto
            aliasPattern: "^[a-zA-Z0-9ÁÉÍÓÚÑáéíóúñ/\\[.?¿\\]/\\s/\\s,/\\s;/\\s:]{2,128}$",//Texto seguro ejm: nombre, dirección, descripción en caja de texto
            textPattern: "^[a-zA-Z0-9ÁÉÍÓÚÑáéíóúñ/\\[.?¿_/-/\\]/\\s/\\s,/\\s;/\\s:]{2,57}$",//Texto seguro ejm: categoría en caja de texto
            filePathPattern: "^[a-zA-Z0-9ÁÉÍÓÚÑáéíóúñ/\\[./\\-_\\]]{7,128}$",//Nombre de archivo
            safeMultilineTextPattern: "^[a-zA-Z0-9ÁÉÍÓÚÑáéíóúñ/\\[/\\]/\\¿/\\?/\\s/\\-/\\_/./\\s/\\,/\\s;/\\s:]{4,256}$",//Texto seguro extenso: descripción en área de texto 256-300 Máximo en SRI
            textAreaPattern: "^[a-zA-Z0-9/./_’'?]{8,57}$",//DESHABILITADO: No usar
            jsonPattern: "^(\\{[^{}]+\\})$",
            jsonPatternSql: '((?:[^"\\]|\\.)*)',
            expressionStringPattern: "^((?!script)[/\\s/\\S])*$",
            sqlPattern: "^((?!CREATE|DROP|UPDATE|INSERT|ALTER|DELETE|ATTACH|DETACH|create|drop|update|insert|alter|delete|attach|detach)[/\\s/\\S])*$",
        },
        validationMsgs: {
            urlPattern: "¡URL inválido!",
            tileURLPattern: "Indique un URL válido",
            urlInteroperabilidadPattern: "¡URL inválido!",
            usernamePattern: "¡Username inválido!",
            emailPattern: "¡Correo electrónico inválido!",
            emailCustomerPattern: "Correo electrónico inválido o ya se encuentra registrado. Si desea utilizar este correo, marque la casilla: ¿Usa un correo electrónico de un familiar u otra persona?",
            numberPattern: "¡Campo requerido o inválido!. Use sólo números",
            codigoPattern: "¡Código inválido!. Use sólo letras, números, guión bajo/medio. Mínimo 8 y máximo 35 caracteres",
            prefixPattern: "¡Prefijo inválido!. No se permiten caracteres especiales. Use sólo letras, números y guión bajo. Mínimo 2 y máximo 7 caracteres",
            fieldNamePattern: "¡Campo requerido o inválido!. No se permiten caracteres especiales. Mínimo 2 y máximo 57 caracteres",
            cedulaPattern: "¡Número CI inválido!. Se requiere 10 dígitos",
            rucPattern: "¡Número RUC inválido!. Se requiere 13 dígitos",
            cirucPattern: "¡Número CI ó RUC inválido!. Se requiere mínimo 10 ó máximo 13 dígitos que sean correctos.",
            establishmentPattern: "¡Número de Establecimiento inválido!. Máximo 3 dígitos, inicia con 0",
            siglasPattern: "¡Siglas inválido!. Use sólo letras, números, guión bajo/medio. Mínimo 2 y máximo 16 caracteres",
            safeTextPattern: "¡Campo requerido o inválido!. No se permiten caracteres especiales. Mínimo 4 y máximo 128 caracteres",
            aliasPattern: "¡Campo requerido o inválido!. No se permiten caracteres especiales. Mínimo 2 y máximo 128 caracteres",
            textPattern: "¡Campo requerido o inválido!. Mínimo 2 y máximo 57 caracteres",
            filePathPattern: "¡Ruta de archivo inválida¡.",
            safeMultilineTextPattern: "¡Campo requerido o inválido!. No se permiten caracteres especiales. Mínimo 4 y máximo 256 caracteres",
            textAreaPattern: "¡Campo requerido o inválido!. No se permiten caracteres especiales. Mínimo 8 y máximo 57 caracteres",//DESHABILITADO: No usar
            jsonPattern: "¡Formato de archivo inválido¡. Se espera un formato JSON",
            expressionStringPattern: "¡Campo requerido o inválido¡. No es un texto de expressión válido",
            sqlPattern: "¡SQL inválido!. Se espera una consulta SQL de selección",
            //Mensajes personalizados
            selectRequired: "¡Item requerido!. Debe seleccionar un item de la lista desplegable",
            radioRequired: "¡Item requerido!. Debe seleccionar un item de la lista",
            //            cirucCustomerInvalid: "¡CI ó RUC inválido!. Se requiere mínimo 10 ó máximo 13 dígitos; y además se aplica validación de digito verificador.",
            cirucCustomerInvalid: "Verifique el número de CI o RUC. El número debe ser válido. La longitud debe ser de CI: 10 dígitos o RUC: 13 dígitos.",
            emissionPointInvalid: "¡Punto de emisión inválido!. Debe seleccionar un punto de emisión del Establecimiento.",
            passwordInvalid: "¡Las Contraseñas no coinciden!",
            dateInvalid: "¡Ingrese una fecha!",
            credentialsInvalid: "Credenciales Incorrectas. El número CI/RUC y/o correo electrónico no son los correctos para el usuario que intenta recuperar.",
            formIvalid: "¡Formulario incompleto o inválido!. Asegúrese que los campos obligatorios estén completos con valores correctos. Por favor complete el formulario e inténte nuevamente.",
            subjectCustomerInvalid: "Se necesita indicar un cliente para asociar al documento.",
        },
        primeng: {

            messages: {
                loadingMsg: "Procesando información, espere por favor...",
                chooseMsg: "Seleccionar",
                chooseNodeMsg: "Seleccione un nodo del árbol",
                chooseItemMsg: "Seleccione un item de la lista",
                emptyMsg: "No se encontraron resultados.",
                noEqualMsg: "No se encontraron coincidencias.",
                fileSendMsg: "El archivo fue enviado al servidor. Ahora se está procesando, espere por favor..",
                fileSendErrorMsg: "No fue posible cargar el archivo. Por favor revise el formato e información e inténte nuevamente.",
                fileXLSResultErrorMsg: "El archivo contiene filas que no se pudieron procesar. Es posible que posean información incompleta.",
                reviewMsg: "Por favor revise la información e inténte nuevamente.",
                verifingMsg: "Verificando...",
                searchRUCMsg: "Tecleé 13 dígitos para realizar una búsqueda...",
                searchMsg: "Teclee por lo menos 3 letras o dígitos para realizar una búsqueda...",
                confirmMsg: "¡Confirmación!",
                confirmTrue: "Sí",
                confirmFalse: "No",
                sugestions: "Sugerencias",
            },
            severities: {
                execute: {
                    success: 'success',
                    warn: 'warn',
                    info: 'info',
                    error: 'error'
                },
            },
            components: {
                table: {
                    selectionMode: "multiple",
                    resizableColumns: true,
                    multiSortMetaOrder: 1, //1ASC, -1DESC
                    selectionModeSingle: "single",
                    rows: 15,
                    paginator: true,
                    filterDelay: 0,
                    sortMode: "multiple",
                    showCurrentPageReport: true,
                },
                tableSummary: {
                    paginator: false,
                },
                tablePopup: {
                    scrollHeight: "300px",
                    scrollHeightMin: "200px",
                    rows: 5,
                },
                tableScroll: {
                    responsiveLayout: "scroll",
                    scrollHeight: "500px",
                    scrollHeightPopup: "200px",
                    rows: 15,
                },
                treeTable: {
                    multiSortMetaOrder: 1, //1ASC, -1DESC
                    selectionMode: "checkbox",
                    rows: 5,
                    paginator: true,
                    resizableColumns: true,
                    filterDelay: 0,
                    sortMode: "multiple",
                    showCurrentPageReport: false,
                },
                tree: {
                    selectionMode: "single",
                    propagateSelectionUp: false,
                    propagateSelectionDown: false,
                    filter: true,
                    filterMode: "lenient",
                    virtualScroll: true,
                    virtualScrollItemSize: 40,
                },
                calendar: {
                    showTime: false,
                    showIcon: true,
                    showButtonBar: true,
                    touchUI: false,
                    touchUIPopup: false,
                    readonlyInput: false,
                    dateFormat: "dd/mm/yy",
                    dateFormatMonth: "mm/yy",
                    dateFormatYear: "yy",
                },
                calendarRead: {
                    readonlyInput: true,
                },
                password: {
                    toggleMask: true,
                    promptLabel: "Ingrese su contraseña...",
                    weakLabel: "Débil",
                    mediumLabel: "Media",
                    strongLabel: "Fuerte",
                    feedback: true,
                    strongRegex: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})",
                    suggestionLetterLower: "Al menos una minúscula",
                    suggestionLetterUpper: "Al menos una mayúscula",
                    suggestionNumber: "Al menos un número",
                    suggestionPattern: "Mínimo 8 caracteres.",
                },
                pickList: {
                    sourceHeader: "No asignados",
                    targetHeader: "Asignados",
                    responsive: true,
                    dragdrop: true,
                },
                listbox: {
                    filter: true,
                    multiple: false,
                    checkbox: false,
                    metaKeySelection: false,
                },
                listboxMultiple: {
                    filter: true,
                    multiple: true,
                    checkbox: true,
                    metaKeySelection: false,
                },
                dropdown: {
                    autoDisplayFirst: true,
                    showClear: true,
                    filter: true,
                },
                autoComplete: {
                    itemSize: 34,
                    minLength: 3,
                    dropdown: true,
                    forceSelection: true,
                    virtualScroll: true,
                    showEmptyMessage: true,
                },
                autoCompleteFree: {
                    forceSelection: false,
                    dropdown: false,
                },
                autoCompleteInput: {
                    dropdown: false,
                },
                input: {
                    autocomplete: false,
                    minLengthCI: 10,
                },
                inputRead: {
                    readonlyInput: true,
                },
                inputNumber: {
                    showButtons: true,
                    min: 0,
                    minFractionDigits: 2,
                    maxFractionDigits: 5,
                },
                textarea: {
                    rows: 5,
                    cols: 30,
                    rowsMin: 2,
                },
                fileUpload: {
                    accept: ".xls, .xlsx",
                    acceptJastReport: ".jasper",
                    fileLimit: 1,
                    maxFileSize: 10000000000,
                    auto: false,
                    showUploadButton: false,
                },
                dialog: {
                    modal: true,
                    position: "center",
                    showHeader: true,
                    closable: true,
                    closeOnEscape: true,
                    resizable: true,
                    blockScroll: false,
                },
                dialogFile: {
                    showHeader: true,
                    closable: true,
                    closeOnEscape: false,
                    resizable: false,
                    blockScroll: true,
                },
                dialogObject: {
                    showHeader: true,
                    closable: false,
                    closeOnEscape: false,
                    resizable: true,
                    blockScroll: false,
                },
                dialogProcess: {
                    showHeader: true,
                    closable: false,
                    closeOnEscape: false,
                    resizable: false,
                    blockScroll: true,
                },
                dialogTree: {
                    showHeader: true,
                    closable: true,
                    closeOnEscape: true,
                    resizable: true,
                    blockScroll: false,
                },
                panel: {
                    toggleable: true,
                    expandIcon: "pi pi-angle-up",
                    collapseIcon: "pi pi-angle-down",
                },
                orderList: {
                    filterMatchMode: "contains",
                },
                scrollTop: {
                    threshold: 50,
                }
            },

        },
        properties: {
            internalStatusInvoice: [
                { name: 'CREATED', value: 'CREATED', color: 'success' },
                { name: 'POSTED', value: 'POSTED', color: 'secondary' },
                { name: 'REJECTED', value: 'REJECTED', color: 'tertiary' },
                { name: 'INVALID', value: 'INVALID', color: 'danger' },
            ],
            invoiceType: [
                { label: "FACTURA DE SERVICIOS PROFESIONALES", value: "SERVICE" },
                { label: "FACTURA COMERCIAL", value: "PRODUCT" },
            ],
            productTypes: [
                { name: 'SERVICIO', value: 'SERVICE' },
                { name: 'PRODUCTO', value: 'PRODUCT' },
            ],
            listTipoFirmaElectronica: [
                { name: 'PERSONA NATURAL', value: 'PERSONA_NATURAL' },
                { name: 'REPRESENTANTE LEGAL', value: 'REPRESENTANTE_LEGAL' },
                { name: 'MIEMBRO EMPRESA', value: 'MIEMBRO_EMPRESA' },
                { name: 'JURIDICA', value: 'JURIDICA' },
                { name: 'ONE SHOT', value: 'ONE SHOT' }
            ],
            listProductTypes: [
                { name: 'SERVICIO', value: 'SERVICE' },
                { name: 'PRODUCTO', value: 'PRODUCT' },
            ],
            ambientes: [
                { name: 'PRODUCCION', value: 'PRODUCCION' },
                { name: 'PRUEBAS', value: 'PRUEBAS' },
            ],
             listTiposPlan: [
                { name: 'Facturación Electrónica', value: 'FACTURACION_ELECTRONICA' },
                { name: 'Firma Electrónica', value: 'FIRMA_ELECTRONICA' },
                { name: 'Agendamiento de citas', value: 'AGENDAMIENTO' },
            ],
            tiposPlan: {
                facturacion: "FACTURACION_ELECTRONICA",
                firma: "FIRMA_ELECTRONICA",
                agendamiento: "AGENDAMIENTO",
            },
            listTiposPeriodos: [
                { name: 'MENSUAL', value: 'MENSUAL' },
                { name: 'TRIMESTRAL', value: 'TRIMESTRAL' },
                { name: 'SEMESTRAL', value: 'SEMESTRAL' },
                { name: 'ANUAL', value: 'ANUAL' },
                { name: 'BIANUAL', value: 'BIANUAL' }
            ],
            tiposPeriodos: {
                mensual: "MENSUAL",
                trimestral: "TRIMESTRAL",
                semestral: "SEMESTRAL",
                anual: "ANUAL",
                bianual: "BIANUAL",
            },
            listGender: [
                { name: 'HOMBRE', value: 'HOMBRE' },
                { name: 'MUJER', value: 'MUJER' }
            ],
            listNacionality: [
                { name: 'ECUATORIANA', value: 'ECUATORIANA' },
                { name: 'EXTRANJERO', value: 'EXTRAJERO' }
            ],
            sitioReferencia: [
                { name: 'Amigo/Familiar', value: 'AMIGO_FAMILIAR', color: 'success' },
                { name: 'Facebook', value: 'FACEBOOK', color: 'secondary' },
                { name: 'Instagran', value: 'INSTAGRAN', color: 'tertiary' },
                { name: 'Email', value: 'EMAIL', color: 'danger' },
                { name: 'Otros', value: 'OTROS', color: 'danger' },
            ],


            defaultActions: {
                execute: {
                    actions: "actions",
                    new: "new",
                    create: "create",
                    add: "add",
                    edit: "edit",
                    save: "save",
                    saveAll: "saveAll",
                    delete: "delete",
                    delete2: "delete2",
                    deleteAll: "deleteAll",
                    copyAll: "copyAll",
                    deleteAll2: "deleteAll2",
                    subCategory: "subCategory",
                    deleteNode: "deleteNode",
                    input: "input",
                    output: "output",
                    config: "config",
                    configFeatures: "configFeatures",
                    register: "register",
                    login: "login",
                    refresh: "refresh",
                    view: "view",
                    upload: "upload",
                    download: "download",
                    uploadXLS: "uploadXLS",
                    downloadXLS: "downloadXLS",
                    downloadPDF: "downloadPDF",
                    finish: "finish",
                    close: "close",
                    back: "back",
                    cancel: "cancel",
                    filter: "filter",
                    enabled: "enabled",
                    disabled: "disabled",
                    expand: "expand",
                    collapse: "collapse",
                    choose: "choose",
                    update: "update",
                    acceptTerm: "acceptTerm",
                    detail: "detail",
                    batch: "batch",
                    up: "up",
                    upAll: "upAll",
                    down: "down",
                    preDownAll: "preDownAll",
                    downAll: "downAll",
                    check: "check",
                    confirmAvaluo: "confirmAvaluo",
                    confirmConstatacion: "confirmConstatacion",
                    confirmRegistro: "confirmRegistro",
                    edit2: "edit2",
                    confirmCodigoSISCAF: "confirmCodigoSISCAF",
                    errorFechaBusqueda: "errorFechaBusqueda",
                    errorCodigoBusqueda: "errorCodigoBusqueda",
                    saves: "saves",
                    depreciaciones: "depreciaciones",
                    copiaValores: "copiaValores",
                    errorCopiaValores: "errorCopiaValores",
                    formIvalidLitsA: "formIvalidLitsA",
                    formIvalidLitsB: "formIvalidLitsB",
                    selectAll: "selectAll",
                    selectAllEquivalencia: "selectAllEquivalencia",
                    confirmar: "confirmar",
                    transferencia: "transferencia",
                    help: "ayuda",
                },
            },
        },
        errorMsgs: {
            errorGeneral: "No fue posible realizar la operación solicitada. Intente nuevamente.",
            error500: "Se ha producido un error inesperado, es posible que el servidor no esté disponible, intente nuevamente.",
            error500_SRI: "Se ha producido un error inesperado al enviar el comprobante al SRI. Es posible que el servicio en el SRI no esté disponible, intente unos minutos después, en la opción [Enviadas sin autorizar -> Enviar SRI]",
            error404: "No se encontró el recurso.",
            error403: "No tiene permisos para acceder al recurso.",
            errorDesconocido: "No fue posible realizar la operación. Recuerde que los nombres deben ser únicos y los datos no deben estar relacionados. Es posible que no tenga los permisos necesarios. Revise e intente nuevamente.",
            errorPermisos: "Verifique que tenga los permisos necesarios.",
        },
        ux: {
            table: {
                selectionMode: "multiple",
                rows: 15,
                paginator: true,
                rowsPerPageOptions: [50, 100, 200],
                scrollable: true,
                scrollHeight: "500px",
                virtualScroll: true,
                virtualScrollItemSize: 40,
                filterDelay: 0,
                sortMode: "multiple",
                showCurrentPageReport: true,
            },
            treetable: {
                selectionMode: "multiple",
                rows: 15,
                paginator: true,
                rowsPerPageOptions: [50, 100, 200],
                scrollable: false,
                scrollHeight: "500px",
                virtualScroll: true,
                virtualScrollItemSize: 40,
                filterDelay: 0,
                sortMode: "multiple",
                showCurrentPageReport: true,
            },
            calendar: {
                showTime: false,
                showIcon: true,
                showButtonBar: false,
                dateFormat: "dd/mm/yy",
            },
            minlengthCIRUC: 10,
            maxlengthCIRUC: 13,
            loadingMsg: "Procesando información, espere por favor...",
            verifingMsg: "Verificando...",
            emptyMsg: "No se encontraron resultados.",
            chooseMsg: "Seleccionar",
            searchRUCMsg: "Teclee por lo menos 10 dígitos para realizar una búsqueda...",
            searchMsg: "Teclee por lo menos 3 letras o dígitos para realizar una búsqueda...",
            formIvalid: "El formulario tiene campos obligatorios vacíos o erróneos. Por favor complete la información correctamente e inténte nuevamente.",
            timeInterval: 20000,
            undefinedString: "No Definido",
            undefinedNumber: "0.00",
            confirmMsg: "¡Confirmación!",
            confirmFalse: "No",
            confirmTrue: "Sí",
            confirmEnvioFacturaDesarrollo: "El comprobante será <strong>autorizado por SRI en el ambiente de PRUEBAS</strong>. El comprobante emitido no genera obligaciones tributarias. ¿Está seguro de continuar?",
            confirmEnvioFacturaProduccion: "El comprobante será <strong>autorizado por SRI y notificada al cliente</strong> generando obligaciones tributarias. ¿Está seguro de continuar?",
            confirmEnvioProformaDesarrollo: "Guardar el pedido. ¿Está seguro de continuar?",
            imgUser: "/assets/layout/icons/user.png",
            imgProduct: "/assets/layout/icons/product.png",
            taxTypes: {
                iva: "IVA",
                none: "NONE",
            },
            actions: {
                create: "Nuevo",
                create_inv: "Nueva",
                recargar: "Recargar",
                edit: "Editar",
                delete: "Eliminar",
                config: "Configurar",
                subscribe: "Suscribirme",
                view: "Visualizar",
                refresh: "Recargar",
                back: "Regresar",
                save: "Guardar",
                cancel: "Cancelar",
                registrarse: "Registrar y empezar a facturar",
                add: "Agregar",
                generatePDF: "Generar PDF",
                download: "Descargar",
                filter: "Filtrar",
                invoicer: "Facturar",
                emitir: "Emitir",
                enabled: "Habilitar",
                disabled: "Deshabilitar",
                finish: "Finalizar",
                home: "Inicio",
                acceptTerm: "¿Acepta términos y condiciones?",
                actions: "Acciones",
                send: "Enviar",
            },
            actionsExecute: {
                new: "new",
                edit: "edit",
                delete: "delete",
                recharge: "recharge",
                subscribe: "subscribe",
                view: "view",
                refresh: "refresh",
                save: "save",
                cancel: "cancel",
                add: "add",
                download: "download",
                filter: "filter",
                invoicer: "invoicer",
                enabled: "enabled",
                disabled: "disabled",
                finish: "finish",
                pago: "pago",
                close: "close",
                login: "login",
            },
            status: {
                enabled: "Habilitado",
                disabled: "Deshabilitado",
                pago: "Pagado",
            },
            messages: {
                success: '¡Muy Bien!',
                warn: '¡Advertencia!',
                info: '¡Información!',
                error: '¡UPS!'
            },
            messagesError: {
                header: 'Mensaje de validación SRI',
                body: 'El comprobante presenta los siguientes errores',
                type: 'error',
                tableSriWithholding: 'withholding',
                tableSriCreditMemo: 'credit_memo',
                tableSriInvoice: 'invoice',
            },
            messagesType: {
                success: 'success',
                warn: 'warn',
                info: 'info',
                error: 'error'
            },
            buttons: {
                primary: 'primary',
                secondary: 'secondary',
                plain: 'plain',
                success: 'success',
                danger: 'danger',
                warning: 'warning',
                help: 'help'
            },
            resultDataButtons: {
                buttonNuevoPedido: {
                    text: 'Nuevo pedido',
                    icon: 'pi pi-apple',
                    cssClass: 'p-button-primary ml-1',
                    action: 'pedido',
                    disabled: false,
                },
                buttonNuevaFactura: {
                    text: 'Nuevo comprobante',
                    icon: 'pi pi-file',
                    cssClass: 'p-button-primary ml-1',
                    action: 'nueva',
                    disabled: false,
                },
                buttonVerListado: {
                    text: 'Ver listado',
                    icon: 'pi pi-database',
                    cssClass: 'p-button-primary ml-1',
                    action: 'listado',
                    disabled: false,
                },
                buttonVerPOS: {
                    text: 'Ir a POS',
                    icon: 'pi pi-heart-fill',
                    cssClass: 'p-button-primary ml-1',
                    action: 'pos',
                    disabled: false,
                },
                buttonOk: {
                    text: 'OK',
                    icon: 'pi pi-check',
                    cssClass: 'p-button-primary ml-1',
                    action: 'close',
                    disabled: false,
                },
                buttonLogin: {
                    text: 'OK',
                    icon: 'pi pi-check',
                    cssClass: 'p-button-primary ml-1',
                    action: 'login',
                    disabled: false,
                },
                buttonStatic: {
                    text: 'Permanecer aquí',
                    icon: 'pi pi-times',
                    cssClass: 'p-button-secondary ml-1',
                    action: 'close',
                    disabled: false,
                },
                buttonSuscription: {
                    text: 'Quiero Suscribirme',
                    icon: 'pi pi-dollar',
                    cssClass: 'p-button-primary ml-1',
                    action: 'suscrib',
                    disabled: false,
                },
                buttonInvoicer: {
                    text: 'Empezar a facturar',
                    icon: 'pi pi-dollar',
                    cssClass: 'p-button-primary ml-1',
                    action: 'invoicer',
                    disabled: false,
                },
            }
        },
        constants: {
            admin: 'admin',
            user: 'usuario',
        },
    },
};
